import ApiClient from '@services/api';
import MockApiClient from '@services/mockApi';

let apiInterface = ApiClient;

if (process.env.API_ENV === 'mock') {
  apiInterface = MockApiClient;
}

export default apiInterface;
